module.exports = __webpack_public_path__ + "assets/img/d966-aq.svg";